'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _utils = require('./../utils');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumberField = function (_AbstractField) {
    (0, _inherits3.default)(NumberField, _AbstractField);

    function NumberField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, NumberField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NumberField.__proto__ || (0, _getPrototypeOf2.default)(NumberField)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                value = _this$props.value,
                double = _this$props.double,
                int = _this$props.int;

            var textValue = e.target.value;

            var normalizeFunc = void 0;
            if (double) {
                normalizeFunc = _utils.commons.normalizeDouble;
            } else if (int) {
                normalizeFunc = _utils.commons.normalizeInt;
            } else {
                normalizeFunc = _utils.commons.normalizeInt;
            }

            var normalizedValue = normalizeFunc(textValue);
            normalizedValue !== value && onChange(normalizedValue);
        }, _this.handleBlur = function () {
            var _this$props2 = _this.props,
                onBlur = _this$props2.onBlur,
                value = _this$props2.value;

            if (onBlur) {
                onBlur(value);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(NumberField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                addonsBefore = _props.addonsBefore,
                addonsAfter = _props.addonsAfter,
                value = _props.value,
                double = _props.double,
                int = _props.int,
                onBlur = _props.onBlur,
                onChange = _props.onChange,
                props = (0, _objectWithoutProperties3.default)(_props, ['addonsBefore', 'addonsAfter', 'value', 'double', 'int', 'onBlur', 'onChange']);


            var inputValue = void 0;
            if (double) {
                inputValue = _utils.commons.normalizeDoubleForUser(value);
            } else if (int) {
                inputValue = value;
            } else {
                inputValue = value;
            }

            var field = _react2.default.createElement(_reactstrap.Input, (0, _extends3.default)({
                type: 'text',
                onChange: this.handleChange,
                onBlur: this.handleBlur,
                value: inputValue
            }, props));

            return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        }
    }]);
    return NumberField;
}(_AbstractField3.default);

NumberField.PropTypes = {
    int: _react2.default.PropTypes.bool,
    double: _react2.default.PropTypes.bool
};
NumberField.defaultProps = {
    int: false,
    double: false
};
exports.default = NumberField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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